/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Stats_CitizensInputs */



/**

* @param {Home_Stats_CitizensInputs} inputs
* @param {{ locale?: "es" }} options
* @returns {LocalizedString}
*/
export const home_stats_citizens = /** @type {((inputs?: Home_Stats_CitizensInputs, options?: { locale?: "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Stats_CitizensInputs, { locale?: "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("de ciudadanos quieren que la IA sea frenada por nuestros gobiernos")
});